module.exports = __webpack_public_path__ + "img/11-lrn-spt-news-ban-470.eccc11a4.svg";